import { render, staticRenderFns } from "./chatRoom.vue?vue&type=template&id=218f2d12"
import script from "./chatRoom.vue?vue&type=script&lang=js"
export * from "./chatRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports